import { render, staticRenderFns } from "./ViewMessage.vue?vue&type=template&id=47c2e5ca&scoped=true&"
import script from "./ViewMessage.vue?vue&type=script&lang=js&"
export * from "./ViewMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c2e5ca",
  null
  
)

export default component.exports